<div class="bookviewer-topbar">
    <div class="row desktop">
        <div bookviewerAccessbilityComponent
             [badgeInstruction]="'Drücke Enter um in das Top-Menü zu gelangen'"
             class="text-center col-lg-6 col-md-6 col-sm-7 ms-auto"
             id="topBookRelated"
        >

            @if (applicationStateService.pageEditMode) {
                <app-current-mode></app-current-mode>
            }

            @if (!applicationStateService.pageEditMode) {
                <button (click)="openModal(myBooksModalKey)"
                        [position]="'center 8px'"
                        [size]="'44px'"
                        [url]="'topbar-icon-digibuch-white-blue.png' | asset"
                        backgroundImage
                        class="top-nav-button"><span>Meine Bücher</span>
                    <i [style.right.px]="25" [style.top.px]="13"
                       aria-hidden="true"
                       class="fa fa-caret-down"></i>
                </button>
                <button (click)="openBookInfoModal()"
                        [position]="'center 5px'"
                        [size]="'25px'"
                        [url]="coverURL"
                        backgroundImage
                        class="top-nav-button"><span>Über das Buch</span>
                    <i [style.right.px]="30" [style.top.px]="13"
                       aria-hidden="true"
                       class="fa fa-caret-down"></i>
                </button>
                @if (applicationStateService.userData.isTeacher) {
                    <button
                            (click)="openMaterialsModal()"
                            [position]="'center 10px'"
                            [size]="'90px'"
                            [url]="'topbar-icon-materialien.png' | asset"
                            backgroundImage
                            class="top-nav-button"><span>Materialien</span>
                        <i [style.right.px]="0" [style.top.px]="13"
                           aria-hidden="true"
                           class="fa fa-caret-down"></i>
                    </button>
                }
                @if (showOfflineVersionButton) {
                    <button
                            (click)="openOfflineVersionModal()"
                            [attr.data-bs-original-title]="!applicationStateService.bookConfig.offlineVersionCreatable ? 'Dieses Buch kann leider nicht als Offline-Version heruntergeladen werden.' : tooltipText"
                            [attr.data-bs-toggle]="applicationStateService.bookConfig.offlineVersionCreatable && !applicationStateService.isOfflineModeEnabled ? 'tooltip' : null"
                            [class.disabled]="!applicationStateService.bookConfig.offlineVersionCreatable"
                            class="top-nav-button"
                            data-placement="right"
                            id="offlineVersionButton">
            <span>
              <i [class.animate]="animate"
                 [class.icon-green]="offlineModeService.check && offlineModeService.check.available"
                 [class.icon-yellow]="offlineModeService.check && !offlineModeService.check.available"
                 class="fas fa-3x fa-folder-download"
              ></i>
                @if (offlineModeService.check && !offlineModeService.check.available) {
                    <i
                            aria-hidden="true"
                            class="fas fa-spinner icon-yellow progress-icon fa-spin"></i>
                }
                @if (offlineModeService.check && offlineModeService.check.available) {
                    <i
                            [class.animate]="animate"
                            aria-hidden="true"
                            class="fas fa-check-circle icon-green progress-icon"></i>
                }
                <br>
                Offline-Version
              </span>
                    </button>
                }
            }
        </div>
        <div bookviewerAccessbilityComponent
             [badgeInstruction]="'Drücke Enter um in das Ansicht-Menü zu gelangen'"
             class="buttons-right col-lg-3 col-md-3 col-sm-3"
             id="topViewControls"
        >
            <div class="button-row">
                @if (applicationStateService.bookConfig.bookSource === 'sia' &&
                !applicationStateService.bookConfig.mBook) {
                    <button
                            (click)="openQuicklinkModal()"
                            (mouseout)="wbook()"
                            (mouseover)="wbookHover()"
                            [position]="'0 0'" [url]="wbookleImgSrc | asset"
                            backgroundImage
                            class="wbook-button"
                            data-bs-html="true"
                            data-bs-placement="bottom"
                            data-bs-toggle="tooltip"
                            title="als <b>W-Buch</b> öffnen">
                        <span></span>
                    </button>
                }
                @if (applicationStateService.bookConfig.hasYedo) {
                    <button
                            (click)="openYedoSignModal()"
                            (mouseout)="yedo()"
                            (mouseover)="yedoHover()"
                            [position]="'0 0'" [url]="yedoImgSrc | asset"
                            backgroundImage
                            class="yedo-button"
                            data-bs-html="true"
                            data-bs-placement="bottom"
                            data-bs-toggle="tooltip"
                            title="als <b>Yedo Buch</b> öffnen">
                        <span></span>
                    </button>
                }
                @if (applicationStateService.bookConfig.mBook) {
                    <button
                            (click)="goToMbookPage()"
                            (mouseout)="mbook()"
                            (mouseover)="mbookHover()"
                            [position]="'0 0'" [url]="mbookleImgSrc | asset"
                            backgroundImage
                            class="mbook-button"
                            data-bs-html="true"
                            data-bs-placement="bottom"
                            data-bs-toggle="tooltip"
                            title="als <b>mbook</b> öffnen">
                        <span></span>
                    </button>
                }
            </div>
            <div class="button-row">
                @if (applicationStateService.bookConfig.readSpeakerEnabled) {
                    <button
                            (click)="toggleReadspeaker()"
                            [class.active]="featureActivationService.readspeakerElementsVisible"
                            [position]="'0 0'"
                            [url]="rsToggleImgSrc | asset"
                            backgroundImage class="rs-toggle-button"
                            data-bs-html="true"
                            data-bs-placement="bottom"
                            data-bs-toggle="tooltip"
                            title="Vorlesefunktion <br/><strong>deaktiviert</strong>">
                        <span></span>
                    </button>
                }
                <app-feature-menu></app-feature-menu>
                <app-viewmode-switcher></app-viewmode-switcher>
            </div>
        </div>
    </div>

    <div class="mobile">
        <div class="row">

            @if (applicationStateService.pageEditMode) {
                <app-current-mode></app-current-mode>
            }

            @if (!applicationStateService.pageEditMode) {
                <div #buttonWrapper (window:resize)="debouncedOnResize()" class="buttons-wrapper">
                    @for (topbarItem of shownItems; track topbarItem) {
                        <button
                                (click)="openComponentInSidebar(topbarItem.component)"
                                [class.active]="sidebarService.activeComponent === topbarItem.component"
                                [class.prominent]="topbarItem.prominent"
                                [position]="topbarItem.position"
                                [size]="topbarItem.iconSize"
                                [style.height.px]="topbarItem.buttonHeight"
                                [url]="topbarItem.icon | asset"
                                backgroundImage
                                class="sidebar-nav-button"><span>{{ topbarItem.label }}</span>
                        </button>
                    }
                    @if (hiddenItems && hiddenItems.length > 1) {
                        <div [style.height.px]="'50'"
                             class="dropdown moreDropdown">
                            <button [class.debug]="env.debug"
                                    [position]="'center 20px'"
                                    [size]="'25px'" [style.height.px]="'50'" [url]="'sidebar/sidebar-icon-more.png' | asset" aria-expanded="true"
                                    aria-haspopup="true"
                                    backgroundImage
                                    class="sidebar-nav-button dropdown-toggle"
                                    data-bs-toggle="dropdown"
                                    id="moreMenu"
                                    type="button"><span>Mehr</span>
                            </button>
                            <ul aria-labelledby="moreMenu" class="dropdown-menu">
                                @for (topbarItem of hiddenItems; track topbarItem) {
                                    <li>
                                        <button (click)="openComponentInSidebar(topbarItem.component)"
                                                [class.active]="sidebarService.activeComponent === topbarItem.component"
                                                [class.prominent]="topbarItem.prominent"
                                                [position]="topbarItem.position"
                                                [size]="topbarItem.iconSize"
                                                [style.height.px]="topbarItem.buttonHeight"
                                                [url]="topbarItem.icon | asset"
                                                backgroundImage
                                                class="sidebar-nav-button dropdown-item"><span>{{ topbarItem.label }}</span>
                                        </button>
                                    </li>
                                }
                            </ul>
                        </div>
                    }
                </div>
                <div class="dropdown-wrapper">
                    <div class="mobile-menu-wrapper">
                        <div>
                            <div class="dropdown static">
                                <button (click)="openComponentInSidebar(mobileBooksContent)" [class.active]="sidebarService.activeComponent === mobileBooksContent"
                                        [position]="'center 3px'"
                                        [size]="'20px'"
                                        [url]="coverURL"
                                        aria-expanded="false"
                                        aria-haspopup="true"
                                        backgroundImage
                                        id="dropdownMenuButton"
                                        type="button">
                                    <span>Bücher</span>
                                    <i aria-hidden="true" class="fa fa-caret-down"></i>
                                </button>
                            </div>
                        </div>
                        <div>
                            <app-user-menu></app-user-menu>
                        </div>
                    </div>
                </div>
            }
        </div>

    </div>
</div>

